/** Sign-in path after session invalidation. */
export const LOGIN_PATH = '/en/sign-in'

/** sessionStorage key: forgot-password-otp path vs sign-up register path on create-password page. */
export const CREATE_PASSWORD_FLOW_KEY = 'createPasswordFlow'
export const CREATE_PASSWORD_FLOW_FORGOT = 'forgot-password-reset'
export const CREATE_PASSWORD_FLOW_REGISTER = 'register'

/** API path for clearing the HTTP-only session cookie. */
export const LOGOUT_URL = '/api/authentication/logout'

export function clearClientSessionData () {
  window.localStorage.clear()
  window.sessionStorage.clear()
}

let global401LogoutInFlight = null

/**
 * Best-effort server logout, clear client storage, redirect to sign-in.
 * Single-flight so parallel 401s do not spam the logout endpoint.
 */
export function scheduleGlobal401Logout () {
  if (global401LogoutInFlight) return global401LogoutInFlight

  global401LogoutInFlight = (async () => {
    try {
      await fetch(LOGOUT_URL, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: '{}'
      })
    } catch (_) {}
    clearClientSessionData()
    window.location.replace(LOGIN_PATH)
  })()

  return global401LogoutInFlight
}

/** Explicit sign-out (user clicked exit). Same as 401 pipeline without retry noise. */
export function performExplicitLogout () {
  return scheduleGlobal401Logout()
}
